// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1L-Ly","large":"styles_large__1I9_U"};